import React, {
  createContext,
  useState,
  useMemo,
  useEffect,
  useContext,
} from "react";
import useToastContext from "../useToastContext";
import { jwtDecode } from "jwt-decode";
import { pathObj } from "../../services/apiPath";
import { apiPost, apiPut } from "../../services/httpServices";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export default AuthContext;
export const AuthProvider = ({ children }) => {
  const notification = useToastContext();
  const navigate = useNavigate();

  //*****  ALL STATE *********//
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [signupSuccess, setSignupSuccess] = useState(false);

  //**** CALL ON PAGE RENDER ******/
  useEffect(() => {
    if (typeof window !== "undefined") {
      const token = localStorage.getItem("token");
      if (token && token !== "undefined" && token !== null) {
        setToken(token ?? null);
        const userDetails = jwtDecode(token);
        if (userDetails) {
          setUser(userDetails);
        }
      } else {
        setToken(null);
      }
    }
  }, []);

  let handleLogin = async (data) => {
    try {
      setLoading(true);
      const response = await apiPost(pathObj.LOGIN, data);
      if (!response?.data?.success) {
        notification?.error(response?.data?.message || "Login failed");
        setLoading(false);
        return;
      }

      const {
        token: localToken,
        refresh_token,
        type,
      } = response?.data?.results || {};

      if (!localToken) {
        notification?.error("Invalid token received");
        setLoading(false);
        return;
      }
      const userDetails = jwtDecode(localToken);
      if (!userDetails) {
        notification?.error("Failed to decode user information");
        setLoading(false);
        return;
      }

      if (userDetails) {
        setUser(userDetails);
        localStorage.setItem("token", localToken);
        localStorage.setItem("refresh_token", refresh_token);
        localStorage.setItem("user-type", type);
        navigate(`/dashboard`);
        notification?.success(response?.data?.message);
        setLoading(false);
      } else {
        notification.error("Something went wrong");
      }
    } catch (error) {
      console.error("Error during login:", error);
      notification?.error(error?.data?.message);
      setLoading(false);
    }
  };
  let handleRegister = async (requestPayload) => {
    try {
      setLoading(true);
      const response = await apiPost(
        pathObj.SIGNUP,
        requestPayload,
        "multipart/form-data"
      );
      if (!response?.data?.success) {
        notification?.error(response?.data?.message || "Signup failed");
        setLoading(false);
        setSignupSuccess(false);
        return;
      }

      setSignupSuccess(true);
      setLoading(false);
    } catch (error) {
      console.error("Error during signup:", error);
      notification?.error(error?.data?.message);
      setLoading(false);
      setSignupSuccess(false);
    }
  };

  let contextData = useMemo(() => ({
    handleLogin,
    user,
    loading,
    token,
    setSidebarToggle,
    sidebarToggle,
    handleRegister,
    signupSuccess,
  }));

  return (
    <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>
  );
};
